import {
  computed,
  inject,
  Injectable,
  linkedSignal,
  resource,
  Signal,
} from '@angular/core';
import { LademittelRepository } from '../repository/lademittel.repository';
import { cancelableResource } from '@softline/core';
import { routeParam } from '@softline/application';
import { Lademittel } from '../types/lademittel';
import { MischPalette } from '@softapps/lager/core';
import { KommissionsauftragBewe } from '../types/kommissionsauftrag';

@Injectable()
export class LademittelService {
  readonly #repository = inject(LademittelRepository);

  readonly id = routeParam('idkopfkomm');

  readonly params = linkedSignal(() => this.id);

  readonly #resource = resource({
    params: () => this.params()() ?? undefined,
    loader: async ({ params }) => {
      console.log('id: ', params);
      return this.#repository.load(params);
    },
  });

  readonly resource = this.#resource.asReadonly();

  readonly items = computed(() => {
    const error = this.#resource.error();
    // resource throws error when accessing value() in error state, so we have to check it
    if (!error) return this.#resource.value() ?? [];
    return [];
  });

  connectParams(params: Signal<string | null>): void {
    this.params.set(params);
  }

  async create(item: Lademittel | null): Promise<MischPalette | undefined> {
    const id = this.id();
    if (!id) return undefined;
    return await this.#repository.create(item, id);
  }

  async createFromExisting(
    item: KommissionsauftragBewe
  ): Promise<MischPalette | undefined> {
    const id = this.id();
    if (!id) return undefined;
    return await this.#repository.createFromExistingOrderItem(item, id);
  }

  async assign(
    idkopfkomm: number,
    palette: any,
    bewekomm: KommissionsauftragBewe,
    menge: number
  ): Promise<KommissionsauftragBewe | undefined> {
    const id = this.id();
    if (!id) return undefined;
    return await this.#repository.assign(
      {
        menge,
        palette,
        bewegung: bewekomm,
      },
      idkopfkomm
    );
  }
}
